import { apiFetch, ApiError } from '@/lib/http/client';

export class LockContentionError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LockContentionError';
  }
}

export interface PromoteResponse {
  entityId: string;
}

export async function promoteVirtualNode(
  canvasId: string,
  nodeId: string,
): Promise<PromoteResponse> {
  try {
    // apiFetch prepends /api automatically — documented endpoint is
    // POST /api/canvas/:id/promote-virtual; path here omits the /api prefix.
    // apiFetch auto-injects Content-Type for non-FormData bodies — no headers needed.
    // encodeURIComponent stays for safety even though canvasId is normally a UUID.
    return await apiFetch<PromoteResponse>(
      `/canvas/${encodeURIComponent(canvasId)}/promote-virtual`,
      {
        method: 'POST',
        body: JSON.stringify({ nodeId }),
      },
    );
  } catch (err) {
    if (err instanceof ApiError && err.status === 409) {
      throw new LockContentionError(err.message);
    }
    throw err;
  }
}
